module.exports = __webpack_public_path__ + "static/media/dialogs@2x.52786388.jpg";